// Shared fetch for the assist log so the pulse header and the "How it's helping" feed read
// one source. In local dev, if /me/assist-log isn't reachable (or returns nothing), falls back
// to a real prod snapshot so the UI is reviewable; never falls back in a production build.
import { useEffect, useState } from "react";
import { getMyAssistLog, getActingOrgId } from "../utils/api";
import assistFixture from "../data/assistFixture";

export default function useAssistLog(space = null) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [usedFixture, setUsedFixture] = useState(false);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    // Fetch on mount (and when the viewed space changes), then re-fetch whenever the user
    // returns to the tab — so the feed/pulse reflect turns captured while they were away.
    const load = async () => {
      // The local-dev fixture is a reviewability aid for one's OWN empty view only — never
      // while impersonating (an impersonated org's truthful empty receipts must show) and
      // never while VIEWING a team space (a fresh space's emptiness is the correct display).
      const impersonating = !!getActingOrgId();
      const allowFixture = process.env.NODE_ENV !== "production" && !impersonating && !space;
      try {
        const live = await getMyAssistLog(space);
        if (!alive) return;
        if (!live?.events?.length && allowFixture) {
          setData(assistFixture); setUsedFixture(true);
        } else {
          setData(live); setUsedFixture(false);
        }
      } catch (e) {
        if (!alive) return;
        if (allowFixture) { setData(assistFixture); setUsedFixture(true); }
        else setData({ totals: {}, events: [], nodes: {} });
      } finally {
        if (alive) setLoading(false);
      }
    };
    load();
    const onFocus = () => { if (document.visibilityState !== "hidden") load(); };
    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onFocus);
    return () => {
      alive = false;
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onFocus);
    };
  }, [space]);

  return { data, loading, usedFixture };
}
